import JobApplicationPage from './JobApplication.page';

export default JobApplicationPage;
